<template>
  <div class="content">
    <h5-header :header-msg="headerMsg" v-show="!isMp"></h5-header>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="nullText" @load="onLoad">
        <van-cell v-for="(item,index) in list" :key="index">
          <div class="cont">
            
            <!-- 优质评价 -->
            <img 
              v-show="item.isHighQuality == 1"
              class="height_quality" 
              src="../../assets/img/pingjia_image_good.png" 
              alt="" />
            <div class="head">
              <img :src="imgUrl + item.headPic" alt="" />
              <div class="right">
                <div class="name_time">
                  <span>{{item.nickName}}</span>
                  <span>{{item.createTime}}</span>
                </div>
                <!-- 星级 -->
                <div class="start">
                  <template v-for="(items,index) in item.starList">
                    <img
                      src="../../assets/img/start/full.png"
                      alt
                      :key="index"
                      v-if="items == 2"
                    />
                    <img
                      src="../../assets/img/start/half.png"
                      alt
                      :key="index"
                      v-if="items == 1"
                    />
                    <img
                      src="../../assets/img/start/empty.png"
                      alt
                      :key="index"
                      v-if="items == 0"
                    />
                  </template>
                </div>
                <div class="goods">
                  <span>商品</span>
                  <p>
                    <template v-for="(items,index) in item.proStarList">
                      <img src="../../assets/img/happy.png" alt v-if="items == 2" :key="index" />
                    </template>
                  </p>
                  <span>配送：</span>
                  <span>{{item.isCourierSatisfaction == 0?'不满意':'满意'}}</span>
                </div>
              </div>
            </div>
            <p class="cont_content">{{item.content}}</p>
            <div class="imgList">
              <img
                :src="imgUrl + items"
                alt
                v-for="(items,index) in item.image"
                :key="index"
                @click="perviewImg(item.image,index)"
              />
            </div>
            <div class="reply" v-if="item.replyContent">
              <span>回复</span>
              <p>{{item.replyContent}}</p>
              <div
                class="reply_img"
                v-for="(items,index) in item.replyVideo"
                :key="index"
                @click="seeVidoe(items.videoId)"
              >
                <img :src="items.videoImage" alt />
                <img src="../../assets/img/order_btn_play.png" alt class="reply_play" />
                <span>{{items.productName}}</span>
              </div>
            </div>
            <div
              class="routes"
              @click="jumpOut(item.chooseFoodPersonName == '' ? item.sellerId : item.chooseFoodPersonId,item.chooseFoodPersonName == ''? 1:0)"
            >
              <img
                :src="imgUrl + item.chooseFoodPersonImage"
                alt
                v-if="item.chooseFoodPersonName != ''"
              />
              <img :src="imgUrl + item.sellerImage" alt v-if="item.chooseFoodPersonName == ''" />
              <div>
                <p>
                  <span>{{item.chooseFoodPersonName ? item.chooseFoodPersonName : item.sellerName}}</span>
                  <!-- <van-icon name="arrow" class="clicks" /> -->
                </p>
                <p v-if="item.chooseFoodPersonName != ''">{{item.sellerName}}</p>
              </div>
              <div class="arrows">
                <van-icon name="arrow" class="clicks" />
              </div>
            </div>
            <div class="delect">
              <van-button type="default" @click="delAssess(item.orderEvaluateId)">删除</van-button>
            </div>
          </div>
          <span class="borders" v-show="list.length>0"></span>
        </van-cell>
      </van-list>
    </van-pull-refresh>

    <div class="nulls" v-show="list.length==0">
      <i class="iconfont icon-meiyouxinxi"></i>
      <p>空空如也</p>
      <p @click="gotoIndex()">去首页逛逛</p>
    </div>
    <van-popup v-model="showVideo" closeable style="height:80%;width:80%;">
      <div style="height:100%;width:100%;">
        <video :src="videoUrl" ref="videoElement" controls autoplay style="width:100%;height:100%;"></video>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { myAssess, delAssess, getVideoUrl } from "@/api/buyer/index";
import { ImagePreview } from "vant";
import { Dialog } from "vant";
import { filterStart } from "@/utils/common.js";
export default {
  data() {
    return {
      headerMsg: {
        title: "我的评价",
        url: ""
      },
      imgUrl: this.imgPrex,
      list: [], //评价列表数据
      loading: false,
      isLoading: false,
      finished: false,
      page: 0,
      isMp: false,
      nullText: "",
      showVideo: false,
      videoUrl: ""
    };
  },
  created() {
    this.$store.commit("user/SET_token", this.GetQueryString("token"));
  },
  mounted() {
    // console.log(this.GetQueryString("type"));
    if (this.GetQueryString("type") == 0) {
      this.isMp = true;
    }
  },
  methods: {
    myAssess(type) {
      let obj = {
        page: {
          way: "1", // 0:不分页 1:分页
          index: this.page.toString(), //请求页
          size: "10" //请求大小
        },
        token: decodeURIComponent(this.GetQueryString("token"))
      };
      myAssess(obj).then(res => {
        if (res.appStatus.errorCode == 0) {
          let dataList = res.content.list;
          for (let i = 0; i < dataList.length; i++) {
            dataList[i].starList = filterStart(
              dataList[i].sellerStarLevel == 0
                ? dataList[i].chooseFoodPersonStarLevel
                : dataList[i].sellerStarLevel
            );
            dataList[i].proStarList = filterStart(dataList[i].productStarLevel);
          }
          if (this.page == 1) {
            this.list = dataList;
          } else {
            this.list = [...(this.list || []), ...dataList];
          }
          if (dataList.length < 10) {
            // 最后一页不足10条的情况
            this.finished = true;
            this.isLoading = false;
            this.loading = false;
            if (dataList.length == 0) {
              this.nullText = "";
              // return;
            } else {
              setTimeout(() => {
                this.nullText = "没有更多了";
              }, 1000);
            }
          } else {
            if (type) {
              this.finished = false;
              setTimeout(() => {
                this.isLoading = false;
              }, 1000);
            }
          }
        } else {
          this.$toast(res.appStatus.message);
        }
      });
    },
    onLoad() {
      // 异步更新数据
      //   setTimeout(() => {
      // for (let i = 0; i < 10; i++) {
      //   this.list.push(this.list.length + 1);
      // }
      // console.log("is ok");
      this.loading = true;
      this.page += 1;
      this.myAssess();
      // 加载状态结束
      // this.loading = false;
      // 数据全部加载完成
      // if (this.list.length >= 40) {
      // this.finished = true;
      //   }, 500);
    },
    perviewImg(images, index) {
      let list = [];
      for (let i = 0; i < images.length; i++) {
        list.push(this.imgUrl + images[i]);
      }
      ImagePreview({
        images: list,
        showIndex: true,
        loop: false,
        startPosition: index
      });
    },
    delAssess(id) {
      Dialog.confirm({
        title: "",
        message: "确定删除评价吗？"
      })
        .then(() => {
          // on confirm
          delAssess({
            orderEvaluateId: id,
            token: this.GetQueryString("token")
          }).then(res => {
            if (res.appStatus.errorCode == 0) {
              this.$toast("删除成功");
              this.page = 1;
              this.myAssess();
            } else {
              this.$toast(res.appStatus.message);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    jumpOut(id, type) {
      if (this.isMp) {
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
            if (type == 0) {
              //选菜师
              wx.miniProgram.navigateTo({
                url: "/pages/choiceFood/choiceFood?chooseFoodPersonId=" + id
              });
            } else {
              //商家
              wx.miniProgram.navigateTo({
                url:
                  "/pages/saleindex/saleindex?data=" +
                  JSON.stringify({
                    position: {
                      latitude: -1,
                      longitude: -1
                    },
                    sellerId: id,
                    sellerProductGoodsId: -1
                  })
              });
            }
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        // console.log(id, type);
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isAndroid) {
          // Android环境
          if (type == 1) {
            window.Android.goToStoreHome(id * 1);
          } else {
            window.Android.goToMPickerHome(id * 1);
          }
        } else {
          if (type == 1) {
            // ios环境
            window.webkit.messageHandlers.goToStoreHome.postMessage({
              sellerId: id
            });
          } else {
            // ios环境
            window.webkit.messageHandlers.goToMPickerHome.postMessage({
              chooseFoodPersonId: id
            });
          }
        }
      }
    },
    onRefresh() {
      this.page = 1;
      // this.list = [];
      this.isLoading = true;
      this.nullText = "";
      this.myAssess(true);
      this.$toast("刷新成功");
    },
    seeVidoe(id) {
      getVideoUrl({
        vodVideoId: id,
        definition: "OD",
        token: decodeURIComponent(this.GetQueryString("token"))
      }).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.videoUrl = res.content.playUrl;
          this.showVideo = true;
        } else {
          this.$toast(res.appStatus.message);
        }
      });
    },
    gotoIndex(){
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
            wx.miniProgram.switchTab({
              url: "/pages/bazaarIndex/bazaarIndex"
            });
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goAppIndex();
        } else {
          // ios环境
          window.webkit.messageHandlers.goAppIndex.postMessage("");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.content {
  /deep/.van-cell {
    padding: 0;
    line-height: 16px;
  }
  .mt {
    margin-top: 44px;
  }
  .cont {
    position: relative;
    width: 100%;
    padding: 0px 15px;
    margin-top: 20px;
    box-sizing: border-box;
    .head {
      width: 100%;
      // height: 40px;
      display: flex;
      // align-items: center;
      > img {
        width: 40px;
        height: 40px;
        border: 1px solid #E1E1E1;
        border-radius: 5px;
        flex-shrink: 0;
        margin-right: 10px;
      }
      .right {
        flex: 1;
        .name_time {
          display: flex;
          align-items: center;
          width: 100%;
          height: 23px;
          span:first-child {
            flex: 1;
            color: #1D1D1D;
            font-size: 16px;
            font-weight: 800;
          }
          span:last-child {
            font-size: 14px;
            color: #999999;
          }
        }
        .start {
          margin-top: 5px;
          line-height: 11px;
          >img {
            width: 12px;
            height: 11px;
          }
        }
        .goods {
          height: 16px;
          margin-top: 6px;
          display: flex;
          align-items: center;
          span {
            display: block;
            font-size: 12px;
            color: #666;
          }
          p {
            display: flex;
            margin: 0 16px 0 3.5px;
            img {
              display: block;
              width: 12px;
              height: 12px;
              margin-right: 2px;
            }
            img:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
    .height_quality {
      width: 51px;
      height: 51px;
      border:none;
      position: absolute;
      right: 20px;
      top: 0px;
    }
    .cont_content {
      color: #1d1d1d;
      font-size: 14px;
      text-align: left;
      margin-top: 8px;
      line-height: 21px;
      font-weight: 400;
    }
    .imgList {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      margin-top: 9px;
      margin-bottom: 9px;
      img {
        width: 112px;
        height: 112px;
        border-radius: 5px;
        margin-right: 4px;
        margin-bottom: 4px;
      }
      img:last-child,
      img:nth-child(3n) {
        margin-right: 0;
      }
    }
    .reply {
      // width: 270px;
      width: 100%;
      height: auto;
      padding: 10px;
      background-color: #FAFAFA;
      border-radius: 5px;
      box-sizing: border-box;
      >span {
        color: #4C4D4E;
        font-size: 14px;
        font-weight: bold;
      }
      .reply_img {
        position: relative;
        width: 105px;
        height: 80px;
        display: inline-block;
        border-radius:0px 0px 5px 5px;
        margin-right: 4px;
        overflow: hidden;
        >span {
          width: 100%;
          height: 22px;
          line-height: 22px;
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 12px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.4);
          text-align: center;
          overflow: hidden;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-radius: 0px 0px 5px 5px;
        }
        >img {
          width: 100%;
          height: 100%;
        }
        .reply_play {
          position: absolute;
          width: 38px;
          height: 38px;
          left: 50%;
          margin-left: -19px;
          margin-top: 13px;
        }
      }
      .reply_img:last-child {
        margin-right: 0;
      }
      p {
        font-size: 13px;
        color: #4C4D4E;
        text-align: left;
        margin-bottom: 8px;
        margin-top: 3px;
        line-height: 18px;
      }
      // img {
      //   width: 88px;
      //   height: 88px;
      //   border-radius: 5px;
      //   margin-left: 0;
      //   display: block;
      // }
    }
    .routes {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      border-radius: 5px;
      background-color: #FAFAFA;
      margin-top: 8px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 2px;
        margin: 5px 7px 5px 10px;
      }
      div {
        height: 100%;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        p {
          color: #333333;
        }
        p:first-child {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          font-weight: 800;
          display: flex;
          align-items: center;
          span {
            max-width: 200px;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          i {
            color: #999999;
            font-size: 16px;
          }
        }
        p:last-child {
          font-size: 12px;
          height: 16px;
          line-height: 16px;
        }
      }
      .arrows {
        margin-left: 12px;
        font-size: 16px;
        color: #999999;
      }
    }
    .delect {
      width: 100%;
      text-align: right;
      margin-top: 8px;
       margin-bottom: 20px;
      /deep/.van-button--normal {
        width: 76px;
        height: 32px;
        line-height: 32px;
        border-radius: 25px;
      }
    }
  }
  
  .borders {
    width: 351px;
    height: 1px;
    display: block;
    margin: 0 12px;
    background: #F0F0F0;
  }
  .nulls {
    width: auto;
    height: auto;
    margin-top: 160px;
    .icon-meiyouxinxi {
      font-size: 160px;
      color: #d6d6d6;
    }
    p:nth-child(2) {
      color: #d6d6d6;
      font-size: 15px;
      margin-top: -40px;
    }
    p:nth-child(3) {
      color: #1993ff;
      font-size: 14px;
      margin-top: 10px;
    }
  }
}
.van-cell:not(:last-child)::after{
  border: none;
}
</style>
